<template>
        <v-main>
        <v-container fluid class="d-flex flex-column min-height container">

            <div class="flex-grow-1 content">
            <NuxtPage/>
            </div>

    </v-container>
    </v-main>
</template>

<script setup>
const navbarStore = useNavbarStore();

const temporary = ref(false)
const route = useRoute();


onMounted(async () => {
  await nextTick();
  handleResize();
  window.addEventListener('resize', handleResize);
});

const handleResize = () => {
  if (window.innerWidth < 1024) {
    if (navbarStore.showNavbar) {
      navbarStore.showNavbar = false;
    }
    temporary.value = true
  } else {
    temporary.value = false
  }
};

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});


</script>
<style scoped>

</style>